import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/list", label: "追更榜单" },
  { to: "/category/rexue", label: "主题分类" },
  { to: "/article/1", label: "追更指南" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const isActive = (to: string) => {
    if (to === "/") return pathname === "/";
    if (to.startsWith("/category")) return pathname.startsWith("/category");
    if (to.startsWith("/article")) return pathname.startsWith("/article");
    return pathname === to || pathname.startsWith(to + "/");
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
      <nav className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-cup-fill text-lg" style={{ width: 18, height: 18 }} />
          </span>
          <span className="font-heading text-xl tracking-wide text-primary-700 whitespace-nowrap">
            可乐漫画
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                isActive(item.to)
                  ? "bg-primary-100 font-medium text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            <i className="ri-chat-smile-3-fill" style={{ width: 16, height: 16 }} />
            联系我们
          </Link>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 bg-background-50 text-foreground-800 md:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={`rounded-lg px-4 py-3 text-sm ${
                  isActive(item.to)
                    ? "bg-primary-100 font-medium text-primary-700"
                    : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center rounded-full bg-primary-500 px-5 py-3 text-sm font-medium text-background-50"
            >
              联系我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}